import { regionByID, regionCreate, regionDestroy, regionList, regionUpdate } from '@/services/ventures/regions.service'

export default {
	namespaced: true,
	state: {
		regionList: { meta: { pagination: { total: 0 } } },
		region: {},
		regionStatus: 'pending',
		regionSaveStatus: 'init',
		regionDeleteStatus: 'init',
	},
	getters: {
		getRegionList: s => s.regionList,
		getRegion: s => s.region,
		getRegionStatus: s => s.regionStatus,
		getRegionSaveStatus: s => s.regionSaveStatus,
		getRegionDeleteStatus: s => s.regionDeleteStatus,
	},
	mutations: {
		REGION_LIST(state, value) { state.regionList = value },
		SET_REGION(state, value) { state.region = value },
		REGION_STATUS(state, value) { state.regionStatus = value },
		REGION_SAVE_STATUS(state, value) { state.regionSaveStatus = value },
		REGION_DELETE_STATUS(state, value) { state.regionDeleteStatus = value },
	},
	actions: {
		async fetchRegionList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('REGION_STATUS', 'pending')
			commit('REGION_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await regionList(params)
				commit('REGION_STATUS', 'init')
				commit('REGION_LIST', data)
				return data
			} catch (error) {
				commit('REGION_STATUS', 'init')
				throw error
			}
		},
		async saveRegion({ commit }, params) {
			commit('REGION_SAVE_STATUS', 'pending')
			try {
				const { data } = await regionCreate(params)
				commit('REGION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REGION_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateRegion({ commit }, params) {
			commit('REGION_SAVE_STATUS', 'pending')
			try {
				const { data } = await regionUpdate(params)
				commit('REGION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REGION_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteRegionByID({ commit }, params) {
			commit('REGION_DELETE_STATUS', 'pending')
			try {
				const { data } = await regionDestroy(params)
				commit('REGION_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REGION_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
